<template>
  <v-container class="none-fluid">
    <banner>Lab Family Culture</banner>
    <div>
      <p>
        The Interaction Lab is a family consisting of various cultures, races, ethnicities, genders, abilities, and socioeconomic backgrounds. We regularly engage in STEM outreach, with efforts and events detailed on
        <a class="link" href="/outreach/">our lab's outreach page</a>
        and on <a class="link" href="http://robotics.usc.edu/~maja/outreach.html"
          >Prof. Matarić's outreach page</a> for groups interested in computing and engineering, as well as for K-12 students. We also started and maintain the <a class="link" href="https://us-women-in-robotics-research.github.io/">
        Github site</a> listing US women who are academic researchers in robotics, to facilitate networking. 
        Students also engage in <a class ="link" href="https://en.wikipedia.org/wiki/Black_in_AI">community</a> <a class ="link" href="https://www.queerinai.com/">outreach</a> to create meaningful connections among peers and provide opportunities for mentorship.
      </p>
      <img
        src="https://firebasestorage.googleapis.com/v0/b/uscinteractionlab.appspot.com/o/diversity_equity_inclusion%2Ffun-lab-1.png?alt=media&token=14de9719-cc5a-4f93-a6ec-a47a4386145d"
      />
      <img
        src="https://firebasestorage.googleapis.com/v0/b/uscinteractionlab.appspot.com/o/diversity_equity_inclusion%2F3.jpg?alt=media&token=8900d8ba-b78b-4895-8dd8-3a45107d21f3"
      />
      <img
        src="https://firebasestorage.googleapis.com/v0/b/uscinteractionlab.appspot.com/o/diversity_equity_inclusion%2FDEF_0705.jpg?alt=media&token=2320983b-4be0-4d49-9a93-45e12a01a24d"
      />
    </div>
  </v-container>
</template>

<script>
import Banner from "../global/Banner";

export default {
  components: {
    Banner,
  },
};
</script>

<style scoped>
img {
  width: 100%;
}
</style>
